/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  BatchErrorData,
  BatchErrorData$inboundSchema,
  BatchErrorData$Outbound,
  BatchErrorData$outboundSchema,
} from "./batcherrordata.js";

export type BatchErrors = {
  object: "list";
  data: Array<BatchErrorData>;
};

/** @internal */
export const BatchErrors$inboundSchema: z.ZodType<
  BatchErrors,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(BatchErrorData$inboundSchema),
});
/** @internal */
export type BatchErrors$Outbound = {
  object: "list";
  data: Array<BatchErrorData$Outbound>;
};

/** @internal */
export const BatchErrors$outboundSchema: z.ZodType<
  BatchErrors$Outbound,
  z.ZodTypeDef,
  BatchErrors
> = z.object({
  object: z.literal("list"),
  data: z.array(BatchErrorData$outboundSchema),
});

export function batchErrorsToJSON(batchErrors: BatchErrors): string {
  return JSON.stringify(BatchErrors$outboundSchema.parse(batchErrors));
}
export function batchErrorsFromJSON(
  jsonString: string,
): SafeParseResult<BatchErrors, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BatchErrors$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BatchErrors' from JSON`,
  );
}
